/* PDP-Experience · Folien 01-08 — Port des Mockup-JS auf echte Produktdaten.
   Jedes Modul ist auf seine Folie (.pdpx.pgN) gescoped und laeuft nur, wenn
   die Section im DOM ist. Add-to-cart (pg1) laeuft ueber das native Form —
   das Theme-Bundle (form[action*="/cart/add"]) uebernimmt AJAX + Drawer. */
(function () {
  "use strict";

  // Eine geschaetzte Note darf neben gemessenen nicht wie eine gemessene
  // aussehen — `prov` kommt aus der Rangliste (siehe lib/payload.js).
  function ipExp(h) { return h && h.prov ? '<em class="expmark">exp.</em> ' : ""; }
  if (window.__pdpxInit) return;
  window.__pdpxInit = true;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  if (!$(".pdpx")) return;

  /* ---------- Toast ---------- */
  var toast = $(".pdpx .js-toast"), tt;
  function say(m) {
    if (!toast) {
      var w = document.createElement("div");
      w.className = "pdpx pg1";
      w.innerHTML = '<div class="toast js-toast" role="status"></div>';
      document.body.appendChild(w);
      toast = w.firstChild;
    }
    toast.textContent = m;
    toast.classList.add("on");
    clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove("on"); }, 2100);
  }
  /* Preise in der WAEHRUNG DES AKTIVEN MARKTS. Vorher hing hier fest " €" dran —
     wer auf CHF oder USD stellte, bekam die richtige Zahl mit falschem Zeichen.
     Die Betraege selbst kommen bereits marktrichtig aus Liquid; nur formatiert
     wird hier. Gleiche Mechanik wie in sections/product-faq.liquid. */
  var PDPX_CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  /* Das Zahlformat vom SERVER lernen statt es zu raten: der in Liquid gerenderte
     Preis zeigt genau, wie der aktive Markt schreibt — Symbol, dessen Position und
     die Trennzeichen ("949,00 €" vs "CHF 1'049.00"). Intl waere hier falsch, weil
     es der Seitensprache folgt (Shop-Wurzel ist EN) und dann "€949.00" ausgibt. */
  var PDPX_MUSTER = (function () {
    var el = document.querySelector(".pdpx .js-price");
    var t = el && el.textContent && el.textContent.trim();
    if (!t) return null;
    var m = t.match(/[\d][\d.,'\s\u00a0\u202f]*/);
    if (!m) return null;
    var zahl = m[0].replace(/[\s\u00a0\u202f]+$/, "");
    return {
      vor: t.slice(0, m.index),
      nach: t.slice(m.index + zahl.length),
      loc: /,\d{2}$/.test(zahl) ? "de-DE" : "en-US"
    };
  })();
  function geld(betrag, ohneCent) {
    var opt = { minimumFractionDigits: ohneCent ? 0 : 2, maximumFractionDigits: ohneCent ? 0 : 2 };
    if (PDPX_MUSTER) return PDPX_MUSTER.vor + betrag.toLocaleString(PDPX_MUSTER.loc, opt) + PDPX_MUSTER.nach;
    try {
      opt.style = "currency"; opt.currency = PDPX_CUR;
      return new Intl.NumberFormat(document.documentElement.lang || undefined, opt).format(betrag);
    } catch (e) {
      return betrag.toFixed(ohneCent ? 0 : 2) + " " + PDPX_CUR;
    }
  }
  function euro(cents) { return geld(cents / 100); }
  function fmt(n) { return geld(n); }

  /* ---------- Folien-Anker: js-goto zeigt sich nur mit Ziel ---------- */
  $$(".pdpx .js-goto").forEach(function (b) {
    if (document.querySelector(b.getAttribute("data-goto"))) b.hidden = false;
  });
  $$(".pdpx .js-popup").forEach(function (b) {
    var has = !!document.querySelector(b.getAttribute("data-popup"));
    if (has) b.hidden = false;
    /* Folie 1 entscheidet die Sichtbarkeit serverseitig (fuer die frueh startende Choreografie) —
       fehlt die Zielfolie doch (im Theme-Editor entfernt), hier wieder verstecken. */
    else if (b.closest("#pdpx-f1")) b.hidden = true;
  });

  /* Size-chart-Modal aus dem pdpx-Scope loesen — gescopte Mockup-Styles + zoom
     verhunzten das V1.12-Modal; am body greift nur noch base.css */
  var scm = document.querySelector(".pdpx [data-size-chart]");
  if (scm) document.body.appendChild(scm);

  /* ---------- Teaser-Popup: Ziel-Folie live ins Modal verschieben ---------- */
  var pwrap = $(".js-pwrap");
  if (pwrap) (function () {
    var pbody = pwrap.querySelector(".js-pbody");
    var ptitle = pwrap.querySelector(".js-ptitle");
    var ph = document.createComment("pdpx-popup-placeholder");
    var moved = null;
    function pOpen(sel, title) {
      var sec = document.querySelector(sel);
      if (!sec || moved) return;
      /* WICHTIG: den .pdpx.pgN-WRAPPER mitnehmen — ohne ihn matchen die
         gescopten Styles nicht und die Folie rendert nackt */
      var unit = sec.closest(".pdpx") || sec;
      unit.parentNode.replaceChild(ph, unit);
      pbody.appendChild(unit);
      if (window.__pdpxLazy) window.__pdpxLazy(unit, true);
      moved = unit;
      ptitle.textContent = title || "";
      pwrap.hidden = false;
      pbody.scrollTop = 0;
      document.body.style.overflow = "hidden";
      if (window.lenis && window.lenis.stop) window.lenis.stop();
    }
    function pClose() {
      if (!moved) { pwrap.hidden = true; return; }
      ph.parentNode.replaceChild(moved, ph);
      moved = null;
      pwrap.hidden = true;
      document.body.style.overflow = "";
      if (window.lenis && window.lenis.start) window.lenis.start();
      if (window.__pdpxFitMid) setTimeout(window.__pdpxFitMid, 80);
    }
    document.addEventListener("click", function (e) {
      var b = e.target.closest(".js-popup");
      if (b) { pOpen(b.getAttribute("data-popup"), b.getAttribute("data-ptitle")); return; }
      if (e.target.closest(".js-pclose")) pClose();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") pClose(); });
  })();

  /* ---------- Mobile: Sticky-Kaufbalken, sobald die Buyrow aus dem Bild ist ---------- */
  (function () {
    var pg1w = $(".pdpx.pg1");
    var buyrow = pg1w && pg1w.querySelector(".buyrow");
    var atc = pg1w && pg1w.querySelector(".js-atc");
    if (!buyrow || !atc || !("IntersectionObserver" in window)) return;
    var bar = document.createElement("div");
    bar.className = "pdpxatc";
    bar.innerHTML = '<span class="pa-t"><b></b><i></i></span><button type="button" class="pa-btn">Add to cart</button>';
    document.body.appendChild(bar);
    var pt = pg1w.querySelector(".btitle");
    bar.querySelector("b").textContent = pt ? pt.textContent.replace(/\s+/g, " ").trim().slice(0, 34) : "";
    function syncPrice() {
      var tot = pg1w.querySelector(".js-total");
      bar.querySelector("i").textContent = tot ? tot.textContent : "";
      bar.querySelector(".pa-btn").disabled = atc.disabled;
    }
    syncPrice();
    /* ereignisgetrieben statt 1,2-s-Polling: .js-total/.js-atc aendern sich nur durch pdpx.js selbst */
    if (window.MutationObserver) {
      var smo = new MutationObserver(syncPrice);
      var tot0 = pg1w.querySelector(".js-total");
      if (tot0) smo.observe(tot0, { childList: true, characterData: true, subtree: true });
      smo.observe(atc, { attributes: true, attributeFilter: ["disabled"] });
    } else { setInterval(syncPrice, 1200); }
    bar.querySelector(".pa-btn").addEventListener("click", function () {
      atc.click();
    });
    /* Scroll-Check statt IntersectionObserver — laeuft auch ohne Compositing */
    var lastChk = 0;
    function checkBar() {
      var now = Date.now();
      if (now - lastChk < 120) return;
      lastChk = now;
      bar.classList.toggle("on", buyrow.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener("scroll", checkBar, { passive: true });
    requestAnimationFrame(checkBar);
  })();

  /* ---------- Mobile: Kit-Waende auf 6 Kacheln kappen, Rest aufklappbar ---------- */
  (function () {
    if (!window.matchMedia("(max-width:860px)").matches) return;
    $$(".pdpx.pg2 .wall").forEach(function (wall) {
      var grp = [];
      function flush() {
        if (grp.length > 6) {
          var extra = grp.slice(6);
          extra.forEach(function (t) { t.classList.add("mhide"); });
          var n = extra.length;
          var wrap = document.createElement("div");
          wrap.className = "mmorewrap";
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "mmore";
          btn.innerHTML = '<span>Show all &middot; ' + n + ' more</span><svg class="chev9" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="#0B8573" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          btn.addEventListener("click", function () {
            var open = btn.classList.toggle("open");
            extra.forEach(function (t) { t.classList.toggle("mhide", !open); });
            if (open && window.__pdpxLazy) window.__pdpxLazy(wall, true);
            btn.querySelector("span").innerHTML = open ? "Show less" : "Show all &middot; " + n + " more";
          });
          wrap.appendChild(btn);
          grp[grp.length - 1].after(wrap);
        }
        grp = [];
      }
      [].slice.call(wall.children).forEach(function (ch) {
        if (ch.classList.contains("wallh")) flush();
        else if (ch.classList.contains("tile")) grp.push(ch);
      });
      flush();
    });
  })();

  /* ---------- Modell-Farben-Galerie (Dekor-Geschwister) ---------- */
  function sibToggle(open) {
    var w = document.querySelector(".js-sibwrap");
    if (!w) return;
    w.hidden = !open;
    document.body.style.overflow = open ? "hidden" : "";
    if (window.lenis) { if (open && window.lenis.stop) window.lenis.stop(); if (!open && window.lenis.start) window.lenis.start(); }
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest(".js-sibopen")) { sibToggle(true); return; }
    if (e.target.closest(".js-sibclose")) sibToggle(false);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var w = document.querySelector(".js-sibwrap");
    if (w && !w.hidden) sibToggle(false);
  });

  /* ---------- Support-Kontakt: Ask-Popup NEUTRAL oeffnen (keine Delivery-Vorbefuellung) ---------- */
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".pdpx.pg7 .askbtn") && !e.target.closest(".js-askneutral")) return;
    setTimeout(function () {
      var box = document.querySelector("[data-ask]");
      if (!box) return;
      var t = box.querySelector("[data-ask-title]");
      if (t) t.textContent = "How can we help?";
      var body = box.querySelector("[data-ask-body]");
      if (body) { body.value = ""; body.placeholder = "Your question — anything about this product or your order"; }
    }, 60);
  });
  document.addEventListener("click", function (e) {
    var b = e.target.closest(".pdpx .js-goto");
    if (!b) return;
    e.preventDefault();
    var t = document.querySelector(b.getAttribute("data-goto"));
    if (t) t.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  /* ---------- Grid-Ranking: Platz 16+ auf-/zuklappen ---------- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest(".js-gridmore");
    if (!b) return;
    var wrap = b.closest(".v1wrap");
    if (!wrap) return;
    var open = b.getAttribute("aria-expanded") === "true";
    $$(".vrow[data-hid]", wrap).forEach(function (r) { r.hidden = open; });
    if (!open && window.__pdpxLazy) window.__pdpxLazy(wrap, true);
    b.setAttribute("aria-expanded", open ? "false" : "true");
    var u = b.querySelector("u");
    if (u) u.textContent = open ? b.getAttribute("data-more-t") : "Show less";
  });

  /* ---------- Choreografie-Klassen (alle Folien) ---------- */
  $$(".pdpx .slide").forEach(function (s) {
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { s.classList.add("go"); io.disconnect(); }
        });
      }, { threshold: 0.12 });
      io.observe(s);
      setTimeout(function () { s.classList.add("go"); io.disconnect(); }, 1200);
    } else { s.classList.add("go"); }
  });

  /* ================= 01 · Stage ================= */
  var pg1 = $(".pdpx.pg1 #pdpx-f1");
  if (pg1) (function () {
    var HCM = { XS: "53–54 cm", S: "55–56 cm", M: "57–58 cm", L: "59–60 cm", XL: "61–62 cm", XXL: "63–64 cm", "3XL": "65–66 cm" };
    function placePuck() {
      var g = $(".sz", pg1);
      if (!g) return;
      var b = g.querySelector('button[aria-pressed="true"]'), p = g.querySelector(".puck");
      if (!b || !p) return;
      p.style.left = b.offsetLeft + "px";
      p.style.width = b.offsetWidth + "px";
      /* Am Handy stehen die Groessen in einem Raster ueber zwei Zeilen — dort muss
         der Marker auch senkrecht wandern. Am Desktop (eine Zeile) bleiben top und
         bottom aus dem CSS stehen. */
      if (getComputedStyle(g).display === "grid") {
        p.style.top = b.offsetTop + "px";
        p.style.height = b.offsetHeight + "px";
        p.style.bottom = "auto";
      } else {
        p.style.top = ""; p.style.height = ""; p.style.bottom = "";
      }
      /* Erst nach der ersten Platzierung animieren, sonst fliegt der Marker
         beim Laden aus der Ecke herein. */
      if (!g.classList.contains("puckbereit")) {
        /* setTimeout statt requestAnimationFrame: rAF ruht in Hintergrund-Tabs,
           die Animation waere dort dauerhaft aus. */
        setTimeout(function () { g.classList.add("puckbereit"); }, 0);
      }
    }
    function applyVariant(b) {
      var avail = b.getAttribute("data-avail") === "1";
      var price = parseInt(b.getAttribute("data-price"), 10) || 0;
      var cmp = parseInt(b.getAttribute("data-cmpat"), 10) || 0;
      var vid = $(".js-vid", pg1); if (vid && b.getAttribute("data-vid")) vid.value = b.getAttribute("data-vid");
      var sku = $(".js-sku", pg1); if (sku && b.getAttribute("data-sku")) sku.textContent = b.getAttribute("data-sku");
      var nb = $(".js-nbody", pg1);
      if (nb && b.getAttribute("data-sku")) nb.value = nb.value.replace(/SKU [^·]*·/, "SKU " + b.getAttribute("data-sku") + " ·");
      var pr = $(".js-price", pg1); if (pr && price) pr.textContent = euro(price);
      var ca = $(".js-cmpat", pg1);
      if (ca) { if (cmp > price) { ca.textContent = euro(cmp); ca.hidden = false; } else { ca.hidden = true; } }
      var out = $(".js-szout", pg1); if (out) out.textContent = b.textContent;
      var h = $(".js-hcm", pg1); if (h) h.textContent = HCM[b.textContent.trim()] || "";
      var atc = $(".js-atc", pg1);
      if (atc) { atc.disabled = !avail; atc.setAttribute("data-price", price); }
      setTotal();
      /* Bestands-Regel (snippets/inventory-status.liquid): high/mid/low/inq/out */
      var card = $(".js-avail", pg1);
      if (card) {
        var st = b.getAttribute("data-st") || "inq";
        var line = card.querySelector(".psline"), txt = card.querySelector(".pstext"), fill = card.querySelector(".psfill");
        line.className = "psline st-" + st;
        txt.textContent = b.getAttribute("data-msg") || "";
        var bw = (b.getAttribute("data-w") || "8") + "%";
        fill.style.width = bw; fill.style.setProperty("--w", bw);
        /* V1.12: Notify/Ask nur bei qty <= 0 */
        var avb = card.querySelector(".js-avbtns");
        if (avb) avb.hidden = !(st === "inq" || st === "out");
      }
      if (typeof fitMid === "function") requestAnimationFrame(fitMid);
    }
    pg1.addEventListener("click", function (e) {
      var b = e.target.closest(".sz button");
      if (!b) return;
      $$(".sz button", pg1).forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
      b.setAttribute("aria-pressed", "true");
      placePuck();
      applyVariant(b);
      var hc = HCM[b.textContent.trim()];
      say("Size " + b.textContent + (hc ? " — head size " + hc : ""));
    });
    function setTotal() {
      var o = $(".js-qv", pg1), t = $(".js-total", pg1), atc = $(".js-atc", pg1), qin = $(".js-qin", pg1);
      if (!o || !t || !atc) return;
      var q = Math.max(1, parseInt(o.textContent, 10) || 1);
      if (qin) qin.value = q;
      t.textContent = euro(q * (parseInt(atc.getAttribute("data-price"), 10) || 0));
    }
    pg1.addEventListener("click", function (e) {
      var b = e.target.closest("[data-q]");
      if (!b) return;
      var o = $(".js-qv", pg1);
      o.textContent = Math.max(1, (parseInt(o.textContent, 10) || 1) + parseInt(b.getAttribute("data-q"), 10));
      setTotal();
    });
    var atcClicked = 0;
    pg1.addEventListener("click", function (e) {
      if (e.target.closest(".js-atc")) atcClicked = Date.now();
    });
    document.addEventListener("cart:added", function () {
      if (Date.now() - atcClicked > 8000) return;
      var b = $(".js-atc", pg1);
      if (!b || b.classList.contains("ok")) return;
      var s = b.querySelector(".t"), t0 = s.textContent;
      b.classList.add("ok");
      s.textContent = "✓ Added";
      setTimeout(function () { b.classList.remove("ok"); s.textContent = t0; }, 1800);
    });
    /* Back-in-stock: Box auf/zu + AJAX-Lead (kein Reload) */
    pg1.addEventListener("click", function (e) {
      var t = e.target.closest(".js-notifytoggle");
      if (!t) return;
      var box = $(".js-notifybox", pg1);
      box.hidden = !box.hidden;
      t.setAttribute("aria-expanded", box.hidden ? "false" : "true");
      if (!box.hidden) { var em = box.querySelector('input[type="email"]'); if (em) em.focus(); }
    });
    var nform = $(".js-notifyform", pg1);
    if (nform) nform.addEventListener("submit", function (e) {
      e.preventDefault();
      var box = $(".js-notifybox", pg1);
      var btn = nform.querySelector(".ngo");
      btn.disabled = true;
      /* Gleiche Infrastruktur wie das Live-System (delivery-notify):
         JSON-Lead an buero.inter-pace.com/lager-alarm, Fallback = natives Form */
      var payload = {
        email: nform.querySelector('input[type="email"]').value,
        variantId: ($(".js-vid", pg1) || {}).value || "",
        sku: ($(".js-sku", pg1) || {}).textContent || "",
        produkt: box.getAttribute("data-produkt") || document.title,
        url: box.getAttribute("data-url") || location.href,
        bild: box.getAttribute("data-bild") || "",
        preis: box.getAttribute("data-preis") || "",
        sprache: document.documentElement.lang || "en",
        anliegen: "stock",
        nachricht: "",
        website: ""
      };
      var done = false;
      function ok() {
        if (done) return; done = true;
        nform.querySelector(".nrow").hidden = true;
        nform.querySelector(".nfine").hidden = true;
        nform.querySelector(".nok").hidden = false;
      }
      var t = setTimeout(function () { if (!done) { done = true; nform.submit(); } }, 3000);
      fetch(box.getAttribute("data-endpoint"), { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(payload) })
        .then(function (r) { clearTimeout(t); if (r.ok) ok(); else if (!done) { done = true; nform.submit(); } })
        .catch(function () { clearTimeout(t); if (!done) { done = true; nform.submit(); } });
    });
    function setView(url, cap) {
      var m = $(".js-main", pg1);
      if (!m) return;
      if (m.tagName === "IMG") { m.removeAttribute("srcset"); m.removeAttribute("sizes"); m.src = url; } else { m.style.backgroundImage = "url(" + url + ")"; }
      var vl = $(".js-viewlab", pg1);
      if (vl) { vl.textContent = cap || ""; vl.hidden = !cap; }
      $$(".thumbs button", pg1).forEach(function (t) {
        var on = t.getAttribute("data-v") === url;
        t.setAttribute("aria-pressed", on ? "true" : "false");
        if (on && t.scrollIntoView) t.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      });
    }
    pg1.addEventListener("click", function (e) {
      var t = e.target.closest(".thumbs button");
      if (t) setView(t.getAttribute("data-v"), t.getAttribute("data-cap") || "");
    });
    /* Bild-Pfeile auf der Stage: hover (Desktop) / dezent sichtbar (mobil);
       steppen durch ALLE Medien (auch die hinter der +N-Kachel) */
    (function () {
      var allThumbs = $$(".thumbs button:not(.js-tplus)", pg1);
      var stg2 = $(".stage", pg1);
      if (allThumbs.length < 2 || !stg2) return;
      function curIdx() {
        for (var i = 0; i < allThumbs.length; i++) {
          if (allThumbs[i].getAttribute("aria-pressed") === "true") return i;
        }
        return 0;
      }
      function step(d) {
        var i = (curIdx() + d + allThumbs.length) % allThumbs.length;
        var t = allThumbs[i];
        setView(t.getAttribute("data-v"), t.getAttribute("data-cap") || "");
      }
      [-1, 1].forEach(function (dir) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "snav " + (dir < 0 ? "sprev" : "snext");
        b.setAttribute("aria-label", dir < 0 ? "Previous image" : "Next image");
        b.innerHTML = '<svg viewBox="0 0 10 16" aria-hidden="true"><path d="M8 1 2 8l6 7" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        b.addEventListener("click", function (e) { e.stopPropagation(); step(dir); });
        b.addEventListener("mousedown", function (e) { e.stopPropagation(); });
        b.addEventListener("touchstart", function (e) { e.stopPropagation(); }, { passive: true });
        stg2.appendChild(b);
      });
    })();
    /* R2-Fit-Karte: huellt die V1.12-Systeme (hpbadge / fitbadge) in den
       Karten-Look — Texte kommen 1:1 aus dem Bundle; Garage-Chips beim Teil */
    (function () {
      var zone = $(".fitzone", pg1);
      if (!zone) return;
      function infoI() {
        return '<span class="infoi"><span class="ii">i</span><span class="tip">Your riding profile at Inter-Pace: head size &amp; shape, your bikes and sizes &mdash; checked automatically on every product page.</span></span>';
      }
      function card(kind, tileHtml, title, sub, actHtml) {
        var d = document.createElement("div");
        d.className = "r2fit " + kind;
        d.innerHTML = '<span class="szk">' + tileHtml + '</span><span class="tx2"><b>' + title + '</b><span class="sub2">' + sub + "</span></span>" + (actHtml || "");
        return d;
      }
      var done = false;
      function mirror(el) {
        var t = document.querySelector("[data-f2-fit]");
        if (t) { t.innerHTML = ""; t.appendChild(el.cloneNode(true)); }
      }
      function build(final) {
        if (done) return;
        /* Universalteil: statische Liquid-Karte (V1.12) steht schon — nichts bauen,
           nur die Bundle-Pille fernhalten */
        if (zone.querySelector(".r2uni")) {
          done = true;
          var fbu = zone.querySelector(".fitbadge");
          if (fbu) fbu.style.display = "none";
          return;
        }
        /* Das Bundle hat den Pass-Zustand gerendert (.ridfit) — der traegt
           Groesse + Verdict selbst; nur die alte Pille verstecken */
        var rf = pg1.querySelector(".ridfit");
        if (rf) {
          var hpx = zone.querySelector(".hpbadge");
          /* !important noetig: eine Mobil-Regel erzwingt die alte Pille (display:flex !important),
             sonst stehen am Handy Pille UND Karte untereinander. */
          if (hpx) hpx.style.setProperty("display", "none", "important");
          done = true;
          /* Verdict unten spiegeln — ohne Edit/Off (deren Handler haengen am Original) */
          var vTxt = (rf.querySelector(".ridfit__txt strong") || {}).textContent || "";
          var vSub = (rf.querySelector(".ridfit__sub") || {}).textContent || "Verified by your Rider-ID";
          var vSize = ((rf.querySelector(".ridfit__size") || {}).textContent || "").replace(/^size\s*/i, "").trim();
          /* Info-i (Rider-ID-Erklaerung) auch an der Bundle-Box oben */
          var subEl = rf.querySelector(".ridfit__sub");
          if (subEl && !subEl.querySelector(".infoi")) subEl.insertAdjacentHTML("beforeend", " " + infoI());
          if (vTxt) {
            var vKind = /not/i.test(vTxt) ? "no" : (/tight|uncertain/i.test(vTxt) ? "amb" : "ok");
            mirror(card(vKind, "<em>Size</em><strong>" + (vSize || "?") + "</strong>", vTxt, vSub + " " + infoI(), ""));
          }
          return;
        }
        var hp = zone.querySelector(".hpbadge");
        var fb = zone.querySelector(".fitbadge");
        /* HELM: CTA oder Status-Pille des Bundles uebernehmen */
        if (hp) {
          var pill = hp.querySelector("[class*='hpbadge__pill--']");
          var cta = hp.querySelector(".hpbadge__cta");
          if (pill) {
            done = true;
            var cls = pill.className;
            var kind = /--ja/.test(cls) ? "ok" : (/--nein/.test(cls) ? "no" : "amb");
            var sym = kind === "ok" ? "\u2713" : (kind === "no" ? "\u2717" : "!");
            var edit = hp.querySelector(".hpbadge__edit");
            var act = '<a class="ed" href="' + (edit ? edit.getAttribute("href") : "#") + '">Edit</a>';
            hp.style.setProperty("display", "none", "important");
            var kp = card(kind, "<em>Fit</em><strong>" + sym + "</strong>", pill.textContent.trim(),
              "Verified by your Rider-ID " + infoI(), act);
            zone.appendChild(kp);
            mirror(kp);
          } else if (cta && (final || !hasPass())) {
            done = true;
            hp.style.setProperty("display", "none", "important");
            var kc = card("cta", "<em>Size</em><strong>?</strong>", "Does this fit me?",
              "Create your Helmet Pass &mdash; saved to your Rider-ID. " + infoI(),
              '<a class="ed go2" href="' + cta.getAttribute("href") + '">Start \u2192</a>');
            zone.appendChild(kc);
            mirror(kc);
          }
          return;
        }
        /* TEIL ohne Garage/aktives Bike: Einladung statt Leere (letzter Versuch,
           damit ein spaetes Bundle-Rendering nicht ueberholt wird) */
        if (fb && (fb.hidden || !fb.textContent.trim()) && (final || !activeBike())) {
          done = true;
          var pen0 = '<button type="button" class="edpen" data-garage-open aria-label="Select your bike" title="Select your bike">' +
            '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="m9.7 2.9 3.4 3.4M2.5 13.5l.8-3.2 7.2-7.2a1.6 1.6 0 0 1 2.3 0l.9.9a1.6 1.6 0 0 1 0 2.3l-7.2 7.2z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
          zone.appendChild(card("cta", "<em>Fit</em><strong>?</strong>", "Does it fit your bike?",
            "Select your bike &mdash; verified by your Rider-ID. " + infoI(), pen0));
          return;
        }
        /* TEIL: fitbadge-Ergebnis + Garage-Stift */
        if (fb && !fb.hidden && fb.textContent.trim()) {
          done = true;
          /* Badge traegt Kurz- UND Langform ("Fits my bike" + "Fits your …") —
             nur die Langform uebernehmen, fuehrendes Symbol strippen */
          var fullEl = fb.querySelector(".fitbadge__full");
          var txt = (fullEl ? fullEl.textContent : fb.textContent).replace(/^[\s\u2713\u2717]+/, "").trim();
          var fits = !/not|kein/i.test(txt);
          /* aktives Garage-Bike namentlich in die Box */
          var act = activeBike();
          if (act && act.label) {
            if (fullEl) txt = txt.replace(/your\s.+$/i, "your " + act.label);
            else txt = txt.replace(/your bike/i, "your " + act.label);
          }
          fb.style.setProperty("display", "none", "important");
          var pen = '<button type="button" class="edpen" data-garage-open aria-label="Change bike" title="Change bike">' +
            '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="m9.7 2.9 3.4 3.4M2.5 13.5l.8-3.2 7.2-7.2a1.6 1.6 0 0 1 2.3 0l.9.9a1.6 1.6 0 0 1 0 2.3l-7.2 7.2z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
          zone.appendChild(card(fits ? "ok" : "no", "<em>Fit</em><strong>" + (fits ? "\u2713" : "\u2717") + "</strong>",
            txt, "Verified by your Rider-ID " + infoI(), pen));
        }
      }
      function hasPass() {
        try { return !!JSON.parse(localStorage.getItem("ip_helm_pass") || "null"); }
        catch (e) { return false; }
      }
      function activeBike() {
        try {
          var g = JSON.parse(localStorage.getItem("ip:garage") || "null");
          if (!g || !Array.isArray(g.bikes)) return null;
          return g.bikes.filter(function (b) { return b.key === g.activeKey; })[0] || null;
        } catch (e) { return null; }
      }
      /* Zustaende ohne Bundle-Abhaengigkeit (kein Pass / keine Garage) bauen
         synchron mit der Seite; auf das Bundle-Rendering reagiert ein
         MutationObserver im selben Frame. Timer nur noch als Sicherheitsnetz. */
      build();
      if (!done) {
        var mo = null;
        if (window.MutationObserver) {
          mo = new MutationObserver(function () { build(); if (done && mo) { mo.disconnect(); mo = null; } });
          mo.observe(pg1, { subtree: true, childList: true, attributes: true, attributeFilter: ["hidden", "class"] });
        }
        setTimeout(build, 900);
        setTimeout(function () { build(true); if (mo) { mo.disconnect(); mo = null; } }, 3500);
      }
    })();

    /* U3: Markt-Gate — Add-to-cart sieht gesperrt aus, bis bestaetigt ist
       (der Submit ist ohnehin durch die required-Checkbox blockiert) */
    (function () {
      var mg = $("[data-homolog-gate]", pg1);
      var atc3 = $(".js-atc", pg1);
      if (!mg || !atc3) return;
      var mgc = mg.querySelector("[data-homolog-check]");
      var hint = mg.querySelector("[data-homolog-hint]");
      if (!mgc) return;
      function mgSync() {
        var ok = mgc.checked;
        atc3.classList.toggle("mglock", !ok);
        if (hint) hint.style.display = ok ? "none" : "";
      }
      mgc.addEventListener("change", mgSync);
      mgSync();
    })();
    var spin = $(".stagewrap.js-spin", pg1);
    if (spin) {
      var ORDER = $$(".thumbs button", pg1).map(function (t) {
        return [t.getAttribute("data-v"), t.getAttribute("data-cap") || ""];
      });
      var sx = null, acc = 0;
      var stageEl = $(".stage", pg1);
      spin.addEventListener("dragstart", function (e) { e.preventDefault(); });
      spin.addEventListener("pointerdown", function (e) {
        if (e.target.closest("button")) return;
        sx = e.clientX; acc = 0;
        spin.classList.add("drag");
        spin.setPointerCapture(e.pointerId);
      });
      spin.addEventListener("pointermove", function (e) {
        if (sx === null) {
          var r = spin.getBoundingClientRect(),
            cx = (e.clientX - r.left) / r.width - 0.5,
            cy = (e.clientY - r.top) / r.height - 0.5;
          stageEl.style.transform = "perspective(900px) rotateY(" + cx * 9 + "deg) rotateX(" + cy * -6 + "deg)";
          return;
        }
        acc += e.clientX - sx; sx = e.clientX;
        if (ORDER.length > 1 && Math.abs(acc) >= 64) {
          var mEl = $(".js-main", pg1); var cur = mEl.tagName === "IMG" ? (mEl.getAttribute("src") || "") : (mEl.style.backgroundImage.match(/url\("?([^")]+)"?\)/) || [0, ""])[1];
          var i = -1;
          ORDER.forEach(function (o, k) { if (o[0] === cur) i = k; });
          /* Wischrichtung wie in jeder Foto-Galerie: der Finger zieht das Bild mit.
             Nach LINKS wischen holt das naechste Bild herein, nach RECHTS das
             vorherige — vorher war beides vertauscht. */
          var n = ((i < 0 ? 0 : i) + (acc < 0 ? 1 : ORDER.length - 1)) % ORDER.length;
          setView(ORDER[n][0], ORDER[n][1]);
          acc = 0;
        }
      });
      var end = function () { sx = null; spin.classList.remove("drag"); stageEl.style.transform = ""; };
      spin.addEventListener("pointerup", end);
      spin.addEventListener("pointercancel", end);
      spin.addEventListener("pointerleave", function () { if (sx === null) stageEl.style.transform = ""; });
    }
    /* Size guide: verdeckten Original-Trigger des size-chart-Snippets klicken
       (document-weit — Folie 02 traegt jetzt auch einen .js-sizeguide-Link) */
    document.addEventListener("click", function (e) {
      var l = e.target.closest(".js-sizeguide");
      if (!l) return;
      e.preventDefault();
      var t = document.querySelector(".size-chart__open");
      if (t) t.click();
    });
    /* Wishlist: sichtbares Feedback nach dem (delegierten) Theme-Toggle */
    pg1.addEventListener("click", function (e) {
      if (!e.target.closest("[data-wishlist-toggle]")) return;
      setTimeout(function () {
        $$("[data-wishlist-toggle]", pg1).forEach(function (b) {
          var onW = b.getAttribute("aria-pressed") === "true";
          if (b.classList.contains("heart")) b.classList.toggle("saved", onW);
          else b.innerHTML = onW ? "♥ Saved to your garage ✓" : "♥ Save — to your garage";
        });
      }, 120);
    });
    /* Spaltenhoehe exakt an den untersten Teaser koppeln (Thumbs enden dort,
       sichtbar im ersten Screen — CSS-svh-Formel kennt die Headerhoehe nicht) */
    /* ---------- Multi-Options-Produkte (Size x Colour, z. B. Kettenraeder):
       Varianten-JSON matcht die Kombi; Farbwechsel tauscht Bild + Preis +
       Bestand. Der alte Size-Handler laeuft zuerst (aria/puck), wir korrigieren
       danach auf die exakte Kombi-Variante. ---------- */
    var vdataEl = $(".js-vdata", pg1);
    if (vdataEl) (function () {
      var V;
      try { V = JSON.parse(vdataEl.textContent); } catch (e) { return; }
      var sel = {};
      $$('.sz button[aria-pressed="true"], .gsz button[aria-pressed="true"], .js-copt[aria-pressed="true"]', pg1).forEach(function (b) {
        sel[b.getAttribute("data-oi")] = b.getAttribute("data-val");
      });
      var sizeOi = null, szb = $(".sz button", pg1);
      if (szb) sizeOi = szb.getAttribute("data-oi");
      function findV(over) {
        var want = {};
        Object.keys(sel).forEach(function (k) { want[k] = sel[k]; });
        if (over) Object.keys(over).forEach(function (k) { want[k] = over[k]; });
        for (var i = 0; i < V.length; i++) {
          var ok = true;
          for (var k in want) { if (V[i].o[k - 1] !== want[k]) { ok = false; break; } }
          if (ok) return V[i];
        }
        return null;
      }
      function stFor(v) {
        if (v.q >= 10) return { st: "high", w: 100, msg: "In stock" };
        if (v.q >= 4) return { st: "mid", w: v.q * 10, msg: v.q + " in stock" };
        if (v.q >= 1) return { st: "low", w: v.q * 10, msg: "Only " + v.q + " left!" };
        if (v.a) return { st: "inq", w: 8, msg: "Delivery time on request" };
        return { st: "out", w: 0, msg: "Sold out — get notified below" };
      }
      function applyV2() {
        var v = findV();
        var atc = $(".js-atc", pg1);
        var card = $(".js-avail", pg1);
        if (!v) {
          if (atc) atc.disabled = true;
          if (card) {
            card.querySelector(".psline").className = "psline st-out";
            card.querySelector(".pstext").textContent = "This combination is not available";
            var f0 = card.querySelector(".psfill"); f0.style.width = "0%"; f0.style.setProperty("--w", "0%");
          }
          return;
        }
        var vid = $(".js-vid", pg1); if (vid) vid.value = v.id;
        var sku = $(".js-sku", pg1); if (sku && v.sku) sku.textContent = v.sku;
        var nb = $(".js-nbody", pg1);
        if (nb && v.sku) nb.value = nb.value.replace(/SKU [^·]*·/, "SKU " + v.sku + " ·");
        var pr = $(".js-price", pg1); if (pr) pr.textContent = euro(v.p);
        var ca = $(".js-cmpat", pg1);
        if (ca) { if (v.c > v.p) { ca.textContent = euro(v.c); ca.hidden = false; } else { ca.hidden = true; } }
        if (atc) { atc.disabled = !v.a; atc.setAttribute("data-price", v.p); }
        setTotal();
        if (card) {
          var st = stFor(v);
          card.querySelector(".psline").className = "psline st-" + st.st;
          card.querySelector(".pstext").textContent = st.msg;
          var f = card.querySelector(".psfill");
          f.style.width = st.w + "%"; f.style.setProperty("--w", st.w + "%");
          var avb = card.querySelector(".js-avbtns");
          if (avb) avb.hidden = !(st.st === "inq" || st.st === "out");
        }
        var out = $(".js-szout", pg1); if (out && sizeOi && sel[sizeOi]) out.textContent = sel[sizeOi];
        if (v.img) setView(v.img, "");
      }
      /* Werte ohne gueltige Kombi dimmen (Groessen wie sonstige Optionen) */
      function markSizes() {
        $$(".sz button, .gsz button", pg1).forEach(function (b) {
          var over = {}; over[b.getAttribute("data-oi")] = b.getAttribute("data-val");
          var v = findV(over);
          if (v && v.a) b.removeAttribute("data-out"); else b.setAttribute("data-out", "1");
        });
      }
      pg1.addEventListener("click", function (e) {
        var b = e.target.closest(".sz button, .gsz button, .js-copt");
        if (!b) return;
        if (b.classList.contains("js-copt")) {
          $$(".js-copt", pg1).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
          var co = $(".js-colout", pg1); if (co) co.textContent = b.getAttribute("data-val");
        }
        var grp = b.closest(".gsz");
        if (grp) {
          $$("button", grp).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
          var gl = $('.js-gout[data-oi="' + b.getAttribute("data-oi") + '"]', pg1);
          if (gl) gl.textContent = b.getAttribute("data-val");
        }
        sel[b.getAttribute("data-oi")] = b.getAttribute("data-val");
        applyV2(); markSizes();
      });
      applyV2(); markSizes();
    })();

    /* STICKY-SICHER v2: mid klemmt beim Scrollen am Viewport — weder Rects
       noch offsetTop liefern dann ihre Flow-Position. Stattdessen die STATISCHE
       aside daneben messen (gleiche Grid-Kante = gleiche Top-Position im Flow);
       Rect-Differenzen im selben Frame sind scroll-invariant. Der 16px-Puffer
       (interne Abstaende) wird im ungeklemmten Zustand gemessen und gemerkt. */
    var fitDelta = 0, fitDeltaKnown = false;
    function fitTarget() {
      var t = $('.js-popup[data-popup="#pdpx-f4"]', pg1);
      var fold = false;
      if (!t || t.hidden) {
        var a = $("aside.buy", pg1);
        t = (a && a.lastElementChild) || $(".saverow", pg1);
        fold = true; /* kein Rating-Teaser: Bild-Spalte am ERSTEN SCREEN deckeln */
      }
      return t ? { t: t, fold: fold } : null;
    }
    var MOBILE = window.matchMedia("(max-width:860px)");
    function fitMid() {
      var mid = $(".mid", pg1), aside = $("aside.buy", pg1);
      if (!mid || !aside) return;
      if (MOBILE.matches) {
        /* Mobil: kein sticky, keine Hoehenkopplung — alles zuruecksetzen */
        mid.style.height = "";
        var stgM = $(".stage", pg1), prodM = $(".js-main", pg1);
        if (stgM) stgM.style.maxHeight = "";
        if (prodM) { prodM.style.height = ""; prodM.style.aspectRatio = ""; }
        return;
      }
      var ft = fitTarget();
      if (!ft) return;
      var target = ft.t;
      var z = parseFloat(getComputedStyle(mid.closest(".pdpx")).zoom) || 1;
      var aTop = aside.getBoundingClientRect().top;
      var tBottom = target.getBoundingClientRect().bottom;
      var h = Math.round((tBottom - aTop) / z);
      var cap = Math.round((innerHeight - 24) / z);
      if (ft.fold) {
        /* Lange Spalten ohne Teaser (Teile): Spalte endet im ersten Screen,
           Bild oben ausrichten — wie die abgenommene Helm-Geometrie wirkt */
        var docTop = aTop + (window.pageYOffset || 0);
        cap = Math.max(360, Math.min(cap, Math.round((innerHeight - docTop - 14) / z)));
      }
      mid.classList.toggle("midfold", ft.fold);
      if (h <= 360) return;
      mid.style.height = Math.min(h, cap) + "px";
      /* Puffer messen geht nur, wenn mid NICHT geklemmt ist (Top == aside-Top) */
      var undEl = $(".under", pg1);
      if (undEl) {
        /* Nicht messen, solange .under und das Zielelement in verschiedenen Transitionsphasen stehen
           (Einblendung der Kaufspalte) — sonst wird ein falscher Puffer gemerkt und die Spalte springt. */
        var unclamped = Math.abs(mid.getBoundingClientRect().top - aTop) < 3 && getComputedStyle(undEl).transform === getComputedStyle(target).transform;
        if (unclamped) {
          var delta = Math.round((undEl.getBoundingClientRect().bottom - tBottom) / z);
          if (delta > 1 && delta < 80) { fitDelta = delta; fitDeltaKnown = true; }
          else if (delta >= -1 && delta <= 1) { fitDelta = 0; fitDeltaKnown = true; }
        }
        if (fitDelta) mid.style.height = (Math.min(h, cap) - fitDelta) + "px";
      }
      /* Stage in den Stagewrap-Content einpassen (clientHeight = Layout, sticky-neutral) */
      var swrap = $(".stagewrap", pg1), stg = $(".stage", pg1), prod = $(".js-main", pg1);
      if (swrap && stg) {
        var scs = getComputedStyle(swrap);
        var ah = Math.floor(swrap.clientHeight - parseFloat(scs.paddingTop) - parseFloat(scs.paddingBottom));
        /* 🔴 19.09.2026: Die Entscheidung MUSS an der ungeklemmten Hoehe haengen. Vorher wurde die schon
           geklemmte Hoehe geprueft (582 ist nicht > 582) -> zuruecksetzen -> 680 > 582 -> wieder klemmen:
           das Bild sprang bei JEDEM Aufruf um. applyVariant() ruft fitMid(), also bei jedem Groessenklick
           (Nutzer 19.09.: „wenn ich groesse 39 ausgewaehlt hab siehts so aus und bei 40 so"). */
        stg.style.maxHeight = "";
        if (prod) { prod.style.height = ""; prod.style.aspectRatio = ""; }
        if (ah > 120 && stg.offsetHeight > ah) {
          stg.style.maxHeight = ah + "px";
          if (prod) { prod.style.height = ah + "px"; prod.style.aspectRatio = "auto"; }
        }
      }
    }
    window.addEventListener("load", fitMid);
    window.addEventListener("resize", function () {
      var mid = $(".mid", pg1);
      if (mid) mid.style.height = "";
      var stg0 = $(".stage", pg1);
      if (stg0) stg0.style.maxHeight = "";
      var prod0 = $(".js-main", pg1);
      if (prod0) { prod0.style.height = ""; prod0.style.aspectRatio = ""; }
      fitDeltaKnown = false;
      requestAnimationFrame(fitMid);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitMid);
    setTimeout(fitMid, 300);
    setTimeout(fitMid, 1200);
    setTimeout(fitMid, 2600);
    window.__pdpxFitMid = fitMid;
    /* Waechter: erwartete Hoehe aus aside/target ableiten (scroll-invariant),
       nur bei Abweichung neu setzen */
    setInterval(function () {
      if (document.hidden || MOBILE.matches) return;
      var mid = $(".mid", pg1), aside = $("aside.buy", pg1);
      if (!mid || !aside || !mid.style.height) return;
      var ft = fitTarget();
      if (!ft) return;
      var target = ft.t;
      var z = parseFloat(getComputedStyle(mid.closest(".pdpx")).zoom) || 1;
      var h = Math.round((target.getBoundingClientRect().bottom - aside.getBoundingClientRect().top) / z);
      var cap = Math.round((innerHeight - 24) / z);
      if (ft.fold) {
        var aT = aside.getBoundingClientRect().top + (window.pageYOffset || 0);
        cap = Math.max(360, Math.min(cap, Math.round((innerHeight - aT - 14) / z)));
      }
      var want = Math.min(h, cap) - fitDelta;
      if (h > 360 && Math.abs(parseFloat(mid.style.height) - want) > 3) fitMid();
    }, 900);
    var active = $('.sz button[aria-pressed="true"]', pg1);
    if (active) applyVariant(active);
    setTotal();
    window.addEventListener("load", placePuck);
    window.addEventListener("resize", placePuck);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placePuck);
    requestAnimationFrame(placePuck);
  })();

  /* ================= 03 · Kit-Studio ================= */
  var pg3 = $(".pdpx.pg2 #pdpx-f3");
  if (pg3) (function () {
    function upd() {
      var sel = $$(".js-pit.sel", pg3), sum = 0;
      sel.forEach(function (p) { sum += parseFloat(p.getAttribute("data-price")); });
      $$(".js-ksum", pg3).forEach(function (s) { s.textContent = "+ " + fmt(sum); });
      $$(".js-kn", pg3).forEach(function (n) { n.textContent = sel.length; });
      var list = $(".js-list", pg3);
      if (list) {
        list.innerHTML = sel.length
          ? sel.map(function (p) {
              return '<div class="r2"><span>' + p.getAttribute("data-name") + "</span><b>+ " +
                fmt(parseFloat(p.getAttribute("data-price"))) + "</b></div>";
            }).join("")
          : '<div class="r2"><span>Nothing picked yet.</span></div>';
      }
    }
    pg3.addEventListener("click", function (e) {
      /* Vorgefertigte Kits (Mockup-Presets): Set laden, Auswahl ersetzen */
      var ps = e.target.closest(".js-preset");
      if (ps) {
        var vids = (ps.getAttribute("data-vids") || "").split(",").filter(Boolean);
        $$(".js-pit", pg3).forEach(function (p2) {
          p2.classList.toggle("sel", vids.indexOf(p2.getAttribute("data-vid")) > -1);
        });
        upd();
        var firstV = $$(".js-pit.sel", pg3).filter(function (p2) { return p2.getAttribute("data-isvisor") && p2.getAttribute("data-img"); })[0];
        if (firstV) $$(".js-prev", pg3).forEach(function (pr) { pr.style.backgroundImage = firstV.getAttribute("data-img"); });
        $$(".js-preset", pg3).forEach(function (x) { x.classList.toggle("on", x === ps && vids.length > 0); });
        say(vids.length ? ps.querySelector("b").textContent + " loaded — tweak it" : "Cleared — build from scratch");
        return;
      }
      var p = e.target.closest(".js-pit");
      if (p) {
        p.classList.toggle("sel");
        upd();
        if (p.classList.contains("sel") && p.getAttribute("data-img") && p.getAttribute("data-isvisor")) {
          $$(".js-prev", pg3).forEach(function (pr) { pr.style.backgroundImage = p.getAttribute("data-img"); });
        }
        return;
      }
      var add = e.target.closest(".js-kitadd");
      if (add && !add.dataset.busy) {
        var sel = $$(".js-pit.sel", pg3);
        if (!sel.length) { say("Kit is empty — tap items to add"); return; }
        add.dataset.busy = "1";
        add.classList.add("is-busy");
        var items = sel.map(function (p) { return { id: parseInt(p.getAttribute("data-vid"), 10), quantity: 1 }; });
        /* Der Helm gehoert dazu — die Karte sagt es selbst ("Kit ships together with
           the helmet"), bisher landeten aber nur die Zubehoerteile im Warenkorb.
           Genommen wird die Variante, die oben in der Kaufspalte gewaehlt ist. */
        var hv = document.querySelector(".pdpx.pg1 .js-vid");
        var hid = hv ? parseInt(hv.value, 10) : 0;
        if (hid) {
          var drin = false;
          items.forEach(function (x) { if (x.id === hid) drin = true; });
          if (!drin) items.unshift({ id: hid, quantity: 1 });
        }
        document.dispatchEvent(new CustomEvent("cart:open", { detail: { pending: true } }));
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: items, sections: ["cart-drawer"] })
        }).then(function (r) { return r.json(); }).then(function (r) {
          /* NUR den Inhalt tauschen, nicht die ganze Section: `replaceWith` warf das
             Drawer-Element samt seinem "offen"-Zustand weg — der Warenkorb schloss
             sich sichtbar und wurde von "cart:added" neu aufgezogen. Das war das
             Auf-Zu-Auf mit den zwei Wartepausen. Gleicher Weg wie im Theme-Bundle. */
          if (r.sections && r.sections["cart-drawer"]) {
            var tmp = document.createElement("div");
            tmp.innerHTML = r.sections["cart-drawer"];
            var neuC = tmp.querySelector("[data-cart-drawer-content]");
            var altC = document.querySelector("[data-cart-drawer-content]");
            if (neuC && altC) { altC.innerHTML = neuC.innerHTML; }
            else {
              var old = document.getElementById("shopify-section-cart-drawer");
              var neu = tmp.firstElementChild;
              if (old && neu) old.replaceWith(neu);
            }
          }
          /* Kopf-Zaehler nachziehen (macht das Bundle bei eigenen Adds genauso) */
          fetch("/cart.js", { headers: { Accept: "application/json" } })
            .then(function (c) { return c.json(); })
            .then(function (c) {
              document.querySelectorAll("[data-cart-count]").forEach(function (el) {
                el.textContent = String(c.item_count);
              });
            }).catch(function () {});
          document.dispatchEvent(new CustomEvent("cart:added"));
          document.dispatchEvent(new CustomEvent("cart:open", { detail: { added: true } }));
          var nTeile = items.length - (hid ? 1 : 0);
          say(hid
            ? "Helmet + " + nTeile + (nTeile === 1 ? " kit item" : " kit items") + " added to cart"
            : items.length + (items.length === 1 ? " kit item" : " kit items") + " added to cart");
        }).catch(function () {
          say("Could not add the kit — please try again");
        }).finally(function () {
          delete add.dataset.busy;
          add.classList.remove("is-busy");
        });
      }
    });
    upd();
  })();

  /* ================= Grid-Daten (04 + 05) ================= */
  var GRID = null, YOU = 0, AXES = ["Safety", "Vent", "Aero", "Comfort", "Quiet", "Value"];
  var gEl = $("[data-pdpx-grid]");
  if (gEl) {
    try {
      var gd = JSON.parse(gEl.textContent);
      GRID = gd.grid;
      GRID.forEach(function (h, i) { if (h.you) YOU = i; });
      if (gd.axes && gd.axes.length) AXES = gd.axes;
    } catch (err) { GRID = null; }
  }

  /* ================= 04 · Rating ================= */
  var pg4 = $(".pdpx.pg4 #pdpx-f4");
  if (pg4) (function () {
    var stage = $("#stage", pg4), cards = $("#cards", pg4);
    var num = stage.querySelector(".js-total");
    var timers = [];
    function countTo(el, v, ms) {
      var start = performance.now();
      (function st() {
        var k = Math.min(1, (performance.now() - start) / ms);
        el.textContent = Math.round(v * (1 - Math.pow(1 - k, 3)));
        if (k < 1) requestAnimationFrame(st);
      })();
    }
    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    var SCORE = parseInt(num.getAttribute("data-v"), 10) || 0;
    function theatre(instant) {
      timers.forEach(clearTimeout); timers = [];
      if (window.__forceInstant) instant = true;
      if (instant) {
        stage.classList.remove("play", "zap", "flash");
        stage.classList.add("done", "fill", "stamp");
        num.textContent = String(SCORE);
        cards.classList.add("cardsgo");
        return;
      }
      stage.classList.remove("done", "zap", "stamp", "flash", "fill");
      cards.classList.remove("cardsgo");
      num.textContent = "0";
      void stage.offsetWidth;
      stage.classList.add("play");
      later(function () { stage.classList.add("done"); }, 1520);
      later(function () { stage.classList.add("fill"); countTo(num, SCORE, 1100); }, 1450);
      later(function () { stage.classList.add("zap"); }, 2450);
      later(function () { stage.classList.add("flash", "stamp"); later(function () { stage.classList.remove("flash"); }, 130); }, 3050);
      later(function () { cards.classList.add("cardsgo"); }, 3250);
    }
    window.__theatre = theatre;
    pg4.addEventListener("click", function (e) { if (e.target.closest(".js-replay")) theatre(false); });
    if ("IntersectionObserver" in window) {
      var io4 = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { theatre(false); io4.disconnect(); }
        });
      }, { threshold: 0.25 });
      io4.observe(stage);
      setTimeout(function () {
        if (!stage.classList.contains("play") && !stage.classList.contains("done")) { theatre(true); io4.disconnect(); }
      }, 2500);
    } else { theatre(true); }

    /* Drag-Spin durch die Media-Frames */
    var FR = [];
    try { FR = JSON.parse(stage.getAttribute("data-frames") || "[]"); } catch (err) { FR = []; }
    var fi = 0, dragging = false, dsx = 0, dacc = 0;
    var lit = $(".helmlit", pg4), base = $(".helmbase", pg4), mir = $(".mirror", pg4), helm = $("#helm", pg4);
    function setFrame(n) {
      if (!FR.length) return;
      fi = ((n % FR.length) + FR.length) % FR.length;
      var v = "url(" + FR[fi] + ")";
      lit.style.backgroundImage = v; base.style.backgroundImage = v; mir.style.backgroundImage = v;
    }
    if (helm && FR.length > 1) {
      helm.addEventListener("pointerdown", function (e) { dragging = true; dsx = e.clientX; dacc = 0; helm.setPointerCapture(e.pointerId); });
      helm.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        dacc += e.clientX - dsx; dsx = e.clientX;
        if (Math.abs(dacc) > 42) { setFrame(fi + (dacc > 0 ? 1 : -1)); dacc = 0; }
      });
      helm.addEventListener("pointerup", function () { dragging = false; });
      helm.addEventListener("pointercancel", function () { dragging = false; });
    }

    /* Leaderboard-Radar-Modal */
    if (GRID) {
      var CX = 150, CY = 128, RMAX = 96;
      function rpt(k, v) {
        var a = -Math.PI / 2 + k * Math.PI / 3;
        return (CX + Math.cos(a) * RMAX * v / 10).toFixed(1) + "," + (CY + Math.sin(a) * RMAX * v / 10).toFixed(1);
      }
      function rpoly(vals) { return vals.map(function (v, k) { return rpt(k, v); }).join(" "); }
      var rsvg = $("#rmodal .rsvg", pg4);
      if (rsvg) {
        var grid = rsvg.querySelector(".rgrid"), axes = rsvg.querySelector(".raxes"), labels = rsvg.querySelector(".rlabels");
        var NS = "http://www.w3.org/2000/svg";
        [3.33, 6.66, 10].forEach(function (r) {
          var pgn = document.createElementNS(NS, "polygon");
          pgn.setAttribute("points", rpoly([r, r, r, r, r, r]));
          grid.appendChild(pgn);
        });
        AXES.forEach(function (n, k) {
          var a = -Math.PI / 2 + k * Math.PI / 3;
          var ln = document.createElementNS(NS, "line");
          ln.setAttribute("x1", CX); ln.setAttribute("y1", CY);
          ln.setAttribute("x2", (CX + Math.cos(a) * RMAX).toFixed(1));
          ln.setAttribute("y2", (CY + Math.sin(a) * RMAX).toFixed(1));
          axes.appendChild(ln);
          var tx = document.createElementNS(NS, "text");
          tx.setAttribute("x", (CX + Math.cos(a) * (RMAX + 14)).toFixed(1));
          tx.setAttribute("y", (CY + Math.sin(a) * (RMAX + 14) + 3).toFixed(1));
          tx.setAttribute("text-anchor", Math.abs(Math.cos(a)) < 0.3 ? "middle" : (Math.cos(a) > 0 ? "start" : "end"));
          tx.textContent = n;
          labels.appendChild(tx);
        });
        rsvg.querySelector(".pyou").setAttribute("points", rpoly(GRID[YOU].radar));
      }
      function openRadar(i) {
        $(".js-rname", pg4).textContent = GRID[i].short;
        $(".js-rname2", pg4).textContent = GRID[i].short;
        $(".js-rscore", pg4).textContent = GRID[i].score;
        $("#rmodal .rsvg .priv", pg4).setAttribute("points", rpoly(GRID[i].radar));
        $("#rmodal", pg4).classList.add("on");
        document.body.style.overflow = "hidden";
      }
      function closeRadar() {
        $("#rmodal", pg4).classList.remove("on");
        document.body.style.overflow = "";
      }
      pg4.addEventListener("click", function (e) {
        var b = e.target.closest(".js-radar");
        if (b) { openRadar(parseInt(b.getAttribute("data-riv"), 10)); return; }
        if (e.target.closest(".js-rclose")) closeRadar();
      });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeRadar(); });
    }
  })();

  /* ================= 05 · Compare ================= */
  var pg5 = $(".pdpx.pg5 #pdpx-f5");
  if (pg5 && GRID) (function () {
    var H = GRID;
    var TUGROWS = [["Safety", "r", 0], ["Ventilation", "r", 1], ["Aero", "r", 2], ["Comfort", "r", 3], ["Quiet", "r", 4], ["Value", "r", 5], ["Price", "p", 0], ["Weight", "w", 0]];
    var NS = "http://www.w3.org/2000/svg";
    function radarInit(svg, cx, cy, rmax, dark) {
      function pt(k, v) {
        var a = -Math.PI / 2 + k * Math.PI / 3;
        return (cx + Math.cos(a) * rmax * v / 10).toFixed(1) + "," + (cy + Math.sin(a) * rmax * v / 10).toFixed(1);
      }
      function poly(vals) { return vals.map(function (v, k) { return pt(k, v); }).join(" "); }
      var grid = document.createElementNS(NS, "g"); grid.setAttribute("class", "rgrid");
      [3.33, 6.66, 10].forEach(function (r) {
        var pgn = document.createElementNS(NS, "polygon");
        pgn.setAttribute("points", poly([r, r, r, r, r, r]));
        pgn.setAttribute("stroke", dark ? "#223029" : "#E4E9E7");
        grid.appendChild(pgn);
      });
      svg.appendChild(grid);
      var axes = document.createElementNS(NS, "g"); axes.setAttribute("class", "raxes");
      var labels = document.createElementNS(NS, "g"); labels.setAttribute("class", "rlabels");
      AXES.forEach(function (n, k) {
        var a = -Math.PI / 2 + k * Math.PI / 3;
        var ln = document.createElementNS(NS, "line");
        ln.setAttribute("x1", cx); ln.setAttribute("y1", cy);
        ln.setAttribute("x2", (cx + Math.cos(a) * rmax).toFixed(1));
        ln.setAttribute("y2", (cy + Math.sin(a) * rmax).toFixed(1));
        ln.setAttribute("stroke", dark ? "#223029" : "#E4E9E7");
        axes.appendChild(ln);
        var tx = document.createElementNS(NS, "text");
        tx.setAttribute("x", (cx + Math.cos(a) * (rmax + 13)).toFixed(1));
        tx.setAttribute("y", (cy + Math.sin(a) * (rmax + 13) + 3).toFixed(1));
        tx.setAttribute("text-anchor", Math.abs(Math.cos(a)) < 0.3 ? "middle" : (Math.cos(a) > 0 ? "start" : "end"));
        tx.setAttribute("fill", dark ? "#5C6C67" : "#93A09B");
        tx.textContent = n;
        labels.appendChild(tx);
      });
      svg.appendChild(axes); svg.appendChild(labels);
      return { poly: poly };
    }
    function addPoly(svg, cls) {
      var pgn = document.createElementNS(NS, "polygon");
      pgn.setAttribute("class", cls);
      svg.appendChild(pgn);
      return pgn;
    }
    function mono(el, g) {
      el.classList.add("mono5");
      el.style.backgroundImage = "none";
      el.textContent = (g.brand || "?").slice(0, 2).toUpperCase();
    }

    /* Duel */
    var c1svg = $("#c1rad", pg5), c1api = radarInit(c1svg, 110, 96, 72, true);
    var c1you = addPoly(c1svg, "pyou"), c1riv = addPoly(c1svg, "priv");
    c1you.setAttribute("points", c1api.poly(H[YOU].radar));
    function tugrows(i) {
      var out = "";
      TUGROWS.forEach(function (t) {
        var lab = t[0], kind = t[1];
        var a, b, al, bl, amax;
        if (kind === "r") { a = H[YOU].radar[t[2]]; b = H[i].radar[t[2]]; al = a + "/10"; bl = b + "/10"; amax = 10; }
        else if (kind === "p") { a = H[YOU].pn; b = H[i].pn; al = H[YOU].price; bl = H[i].price; amax = Math.max(a, b); a = amax * 2 - a; b = amax * 2 - b; amax = Math.max(a, b); }
        else { a = H[YOU].weight; b = H[i].weight; al = H[YOU].weight + " g"; bl = H[i].weight + " g"; amax = Math.max(a, b); a = amax * 2 - a; b = amax * 2 - b; amax = Math.max(a, b); }
        var aw = Math.round(a / amax * 100), bw = Math.round(b / amax * 100);
        out += '<div class="tugrow' + (a === b ? "" : " has-win") + '"><span class="tside l' + (a > b ? " win" : "") + '"><i style="width:' + aw + '%"></i><u>' + al + "</u></span>" +
          '<span class="tlab5">' + lab + (a === b ? "<b class=\"tie\">tie</b>" : (a > b ? "<b>" + H[YOU].short + "</b>" : "<b>" + H[i].short + "</b>")) + "</span>" +
          '<span class="tside r' + (b > a ? " win" : "") + '"><i style="width:' + bw + '%"></i><u>' + bl + "</u></span></div>";
      });
      $("#c1tugs", pg5).innerHTML = out;
    }
    function pickRival(i) {
      var h = H[i];
      $("#c1name", pg5).textContent = h.short;
      $("#c1score", pg5).innerHTML = ipExp(h) + h.score + "<em>/100</em>";
      var lvl = $("#c1lvl", pg5);
      lvl.textContent = h.lvl;
      lvl.className = "flvl" + (h.lvl === "Benchmark" ? " bmk" : "");
      $("#c1flag", pg5).innerHTML = '<span class="flag cc-' + h.cc + '"></span>';
      var helm = $("#c1helm", pg5);
      if (h.img) {
        helm.classList.remove("mono5");
        helm.style.backgroundImage = "url(" + h.img + ")";
        helm.textContent = "";
      } else { mono(helm, h); }
      c1riv.setAttribute("points", c1api.poly(h.radar));
      tugrows(i);
      $$(".js-pick1", pg5).forEach(function (x) { x.classList.toggle("on", parseInt(x.getAttribute("data-i"), 10) === i); });
      var plus = $(".js-morepick", pg5);
      if (plus) {
        var inbar = $$(".rivrow > .rpick.js-pick1", pg5).some(function (x) { return parseInt(x.getAttribute("data-i"), 10) === i; });
        plus.classList.toggle("on", !inbar);
      }
    }
    pg5.addEventListener("click", function (e) {
      var mp = e.target.closest(".js-morepick");
      if (mp) {
        var rm = $(".js-rivmenu", pg5);
        if (rm) { rm.hidden = !rm.hidden; mp.setAttribute("aria-expanded", rm.hidden ? "false" : "true"); }
        return;
      }
      var b = e.target.closest(".js-pick1");
      if (b) {
        pickRival(parseInt(b.getAttribute("data-i"), 10));
        var rm2 = b.closest(".js-rivmenu");
        if (rm2) rm2.hidden = true;
      }
    });
    /* Default-Gegner: der Platz direkt HINTER dem angeschauten Helm
       (P5 -> P6); ist er Letzter, der davor. Grid ist rangsortiert. */
    var firstRiv = (YOU + 1 < H.length) ? YOU + 1 : Math.max(0, YOU - 1);
    pickRival(firstRiv);

    /* Radar (Command-Center) */
    var c2svg = $("#c2rad", pg5), c2api = radarInit(c2svg, 170, 148, 108, false);
    var c2you = addPoly(c2svg, "pyou");
    c2you.setAttribute("points", c2api.poly(H[YOU].radar));
    var CCCOL = ["#101413", "#0B8573", "#7A6CD8", "#D8656C", "#C99A2E"];
    var c2active = [], c2polys = [];
    for (var ci5 = YOU + 1; ci5 < H.length && c2active.length < 2; ci5++) { if (!H[ci5].you) c2active.push(ci5); }
    for (var cj5 = YOU - 1; cj5 >= 0 && c2active.length < 2; cj5--) { if (!H[cj5].you) c2active.push(cj5); }
    function c2focus(i) {
      var h = H[i];
      var out = '<div class="fh">' + (h.img ? '<span class="ti" style="background-image:url(' + h.img + ')"></span>' : '<span class="ti mono5">' + (h.brand || "?").slice(0, 2).toUpperCase() + "</span>") +
        "<b>" + h.short + '</b><span class="fscore">' + ipExp(h) + h.score + "<em>/100</em></span></div>";
      AXES.forEach(function (ax, k) {
        var a = H[YOU].radar[k], b = h.radar[k];
        out += '<div class="dline"><span>' + ax + '</span><span class="db"><i class="riv3" style="left:0;width:' + (b * 10) + '%"></i><i class="you3" style="left:0;width:' + (a * 10) + '%;opacity:.85"></i></span><span class="dv"><em>' + a + "</em> vs " + b + "</span></div>";
      });
      var dd = H[YOU].score - h.score;
      out += '<div class="dline"><span>Verdict</span><span></span><span class="dv"><em>' + (dd >= 0 ? "+" + dd : dd) + " pts</em> to " + H[YOU].short + "</span></div>";
      $("#c2focus", pg5).innerHTML = out;
    }
    function c2render() {
      c2polys.forEach(function (p) { p.remove(); });
      c2polys = [];
      var leg = '<span class="lg"><i style="background:var(--mint)"></i>' + H[YOU].short + " · " + H[YOU].score + "</span>";
      c2active.forEach(function (idx, k) {
        var pgn = addPoly(c2svg, "p2");
        pgn.setAttribute("points", c2api.poly(H[idx].radar));
        pgn.setAttribute("stroke", CCCOL[k]);
        pgn.setAttribute("stroke-dasharray", k === 0 ? "" : "5 4");
        c2polys.push(pgn);
        leg += '<span class="lg"><i style="background:' + CCCOL[k] + '"></i>' + H[idx].short + " · " + H[idx].score + "</span>";
      });
      $("#c2leg", pg5).innerHTML = leg;
      $$(".js-cc", pg5).forEach(function (x) {
        var i = parseInt(x.getAttribute("data-i"), 10), k = c2active.indexOf(i);
        x.classList.toggle("on", k > -1);
        x.style.setProperty("--c", k > -1 ? CCCOL[k] : "#101413");
      });
      c2focus(c2active.length ? c2active[c2active.length - 1] : firstRiv);
    }
    pg5.addEventListener("click", function (e) {
      var cp = e.target.closest(".js-ccmore");
      if (cp) {
        var cm = $(".js-ccmenu", pg5);
        if (cm) { cm.hidden = !cm.hidden; cp.setAttribute("aria-expanded", cm.hidden ? "false" : "true"); }
        return;
      }
      var b = e.target.closest(".js-cc");
      if (!b) return;
      var i = parseInt(b.getAttribute("data-i"), 10), k = c2active.indexOf(i);
      if (k > -1) c2active.splice(k, 1);
      else {
        if (c2active.length >= 5) { say("Max 5 rivals on the radar — deselect one first"); return; }
        c2active.push(i);
      }
      var cm2 = b.closest(".js-ccmenu");
      if (cm2 && k === -1) cm2.hidden = true;
      c2render();
    });
    c2render();

    /* Plus-Menues (Duel + Radar): das GANZE Feld durchsuchen und filtern.
       Zeilen tragen js-pick1 bzw. js-cc — die bestehenden Handler greifen. */
    $$(".pmenu", pg5).forEach(function (menu) {
      var mode = menu.getAttribute("data-mode");
      var list = menu.querySelector(".pmlist");
      var search = menu.querySelector(".pmsearch");
      var state = { q: "", brand: "", lvl: "" };
      function chips(field, label) {
        var box = menu.querySelector('.pmchips[data-f="' + field + '"]');
        if (!box) return;
        var vals = [];
        H.forEach(function (h) { if (!h.you && h[field] && vals.indexOf(h[field]) < 0) vals.push(h[field]); });
        if (vals.length < 2) { box.hidden = true; return; }
        var out = '<button type="button" class="pmchip on" data-v="">' + label + "</button>";
        vals.forEach(function (v) { out += '<button type="button" class="pmchip" data-v="' + v.replace(/"/g, "&quot;") + '">' + v + "</button>"; });
        box.innerHTML = out;
        box.addEventListener("click", function (e) {
          var c = e.target.closest(".pmchip");
          if (!c) return;
          state[field] = c.getAttribute("data-v");
          $$(".pmchip", box).forEach(function (x) { x.classList.toggle("on", x === c); });
          rows();
        });
      }
      function rows() {
        var out = "";
        H.forEach(function (h, i) {
          if (h.you) return;
          if (state.brand && h.brand !== state.brand) return;
          if (state.lvl && h.lvl !== state.lvl) return;
          if (state.q && ((h.name || "") + " " + (h.brand || "")).toLowerCase().indexOf(state.q) < 0) return;
          out += '<button type="button" class="mitem ' + (mode === "duel" ? "js-pick1" : "js-cc") + '" data-i="' + i +
            '"><i class="plab3">P' + (i + 1) + "</i>" +
            (h.img ? "<span class='mti' style='background-image:url(\"" + String(h.img).replace(/"/g, "%22") + "\")'></span>" : "") +
            "<b>" + h.name + '</b><em class="mbrand">' + (h.brand || "") + '</em><span>' + ipExp(h) + h.score + "</span></button>";
        });
        list.innerHTML = out || '<p class="pmempty">No helmet matches &mdash; clear search or filters.</p>';
        if (mode === "radar") {
          $$(".mitem.js-cc", list).forEach(function (x) {
            x.classList.toggle("on", c2active.indexOf(parseInt(x.getAttribute("data-i"), 10)) > -1);
          });
        } else {
          var cur = $(".rivrow .rpick.js-pick1.on", pg5);
        }
      }
      if (search) search.addEventListener("input", function () { state.q = search.value.trim().toLowerCase(); rows(); });
      chips("brand", "All brands");
      chips("lvl", "All levels");
      rows();
      menu.__refresh = rows;
    });
    /* Beim Oeffnen: Liste auffrischen + Suchfeld fokussieren */
    pg5.addEventListener("click", function (e) {
      if (!e.target.closest(".js-morepick") && !e.target.closest(".js-ccmore")) return;
      $$(".pmenu", pg5).forEach(function (m) {
        if (!m.hidden) {
          if (m.__refresh) m.__refresh();
          var sf = m.querySelector(".pmsearch");
          if (sf) setTimeout(function () { sf.focus(); }, 30);
        }
      });
    });

    /* Matrix: beste Werte markieren */
    $$(".mx tbody tr[data-best]", pg5).forEach(function (tr) {
      var mode = tr.getAttribute("data-best");
      var tds = $$("td", tr);
      if (mode === "flag") {
        tds.forEach(function (td) { if (td.getAttribute("data-v") === "1") td.classList.add("best"); });
        return;
      }
      var vals = tds.map(function (td) { return parseFloat(td.getAttribute("data-v")); });
      var best = mode === "min" ? Math.min.apply(null, vals) : Math.max.apply(null, vals);
      tds.forEach(function (td, i) { if (vals[i] === best) td.classList.add("best"); });
    });
    $$(".mx tbody tr", pg5).forEach(function (tr) {
      var tds = $$("td[data-lvl]", tr);
      tds.forEach(function (td) { td.classList.add("best"); });
    });

    /* Tabs */
    pg5.addEventListener("click", function (e) {
      var t = e.target.closest(".cmt");
      if (e.target.closest(".js-gomx")) t = $('.cmt[data-t="matrix"]', pg5);
      if (!t) return;
      $$(".cmt", pg5).forEach(function (x) { x.classList.toggle("on", x === t); });
      $$(".tpan", pg5).forEach(function (pn) {
        pn.hidden = pn.getAttribute("data-p") !== t.getAttribute("data-t");
        if (!pn.hidden && window.__pdpxLazy) window.__pdpxLazy(pn, true);
      });
    });
  })();

  /* ================= 06 · Look ================= */
  var pg6 = $(".pdpx.pg6 #pdpx-f6");
  if (pg6) (function () {
    var picks = {};
    $$(".strow", pg6).forEach(function (row) {
      var fixed = row.querySelector(".js-st.fixed.on");
      if (fixed) picks[row.getAttribute("data-zone")] = fixed;
    });
    function fmt0(v) { return geld(v, true); }
    function selCount() {
      var n = 0;
      Object.keys(picks).forEach(function (z) {
        if (picks[z] && !picks[z].classList.contains("fixed")) n++;
      });
      return n;
    }
    function sum() {
      var t = 0, cov = 0, avail = 0, pips = "";
      $$(".strow", pg6).forEach(function (row) {
        avail++;
        var z = row.getAttribute("data-zone"), p = picks[z];
        if (p) { t += parseFloat(p.getAttribute("data-p")) || 0; cov++; }
        row.classList.toggle("cov", !!p);
        pips += '<span class="pip' + (p ? " on" : "") + '"></span>';
      });
      var s = $(".js-h2tsum", pg6); if (s) s.textContent = fmt0(t);
      var c = $(".js-cov", pg6); if (c) c.textContent = cov + " of " + avail + " covered";
      var pp = $(".js-pips", pg6); if (pp) pp.innerHTML = pips;
      var ab = $(".js-lookadd", pg6);
      if (ab) {
        var n = selCount();
        ab.disabled = n === 0;
        ab.textContent = n ? "Add look to cart (" + n + ")" : "Add look to cart";
      }
    }
    pg6.addEventListener("click", function (e) {
      var ab = e.target.closest(".js-lookadd");
      if (ab && !ab.dataset.busy) {
        var sel = [];
        Object.keys(picks).forEach(function (z) {
          var p = picks[z];
          if (p && !p.classList.contains("fixed") && p.getAttribute("data-vid")) {
            sel.push({ id: parseInt(p.getAttribute("data-vid"), 10), quantity: 1 });
          }
        });
        if (!sel.length) return;
        ab.dataset.busy = "1";
        document.dispatchEvent(new CustomEvent("cart:open", { detail: { pending: true } }));
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: sel, sections: ["cart-drawer"] })
        }).then(function (r) { return r.json(); }).then(function (r) {
          if (r.sections && r.sections["cart-drawer"]) {
            var old = document.getElementById("shopify-section-cart-drawer");
            if (old) {
              var tmp = document.createElement("div");
              tmp.innerHTML = r.sections["cart-drawer"];
              if (tmp.firstElementChild) old.replaceWith(tmp.firstElementChild);
            }
          }
          document.dispatchEvent(new CustomEvent("cart:added"));
          say(sel.length + (sel.length === 1 ? " piece" : " pieces") + " added — double-check sizes in the cart");
        }).catch(function () {
          say("Could not add the look — please try again");
        }).finally(function () { delete ab.dataset.busy; });
        return;
      }
      if (e.target.closest(".openlnk")) return;
      var card = e.target.closest(".js-st");
      if (!card || card.classList.contains("fixed")) return;
      var row = card.closest(".strow"), zone = row.getAttribute("data-zone");
      if (card.classList.contains("on")) {
        card.classList.remove("on");
        card.querySelector("u").textContent = "Tap to add";
        delete picks[zone];
      } else {
        $$(".js-st", row).forEach(function (x) {
          if (!x.classList.contains("fixed")) {
            x.classList.remove("on");
            x.querySelector("u").textContent = "Tap to add";
          }
        });
        card.classList.add("on");
        card.querySelector("u").textContent = "In your look";
        picks[zone] = card;
      }
      sum();
    });
    sum();
  })();

  /* ================= 07 · Support ================= */
  var pg7 = $(".pdpx.pg7 #pdpx-f7");
  if (pg7) (function () {
    /* Echter Estimator (Muster: sections/product-faq.liquid) — Artikel kurz in
       den Cart legen, /cart/shipping_rates.json = ECHTE Checkout-Raten, Menge
       danach zuruecksetzen. */
    var EU = ["Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czechia", "Czech Republic", "Denmark", "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Ireland", "Italy", "Latvia", "Lithuania", "Luxembourg", "Malta", "Netherlands", "Poland", "Portugal", "Romania", "Slovakia", "Slovenia", "Spain", "Sweden"];
    var CC = { "Germany": "de", "Austria": "at", "Switzerland": "ch", "France": "fr", "Italy": "it", "Netherlands": "nl", "United Kingdom": "gb", "United States": "us", "Japan": "jp", "Spain": "es", "Portugal": "pt", "Indonesia": "id" };
    function esc(s) { var d = document.createElement("i"); d.textContent = s == null ? "" : String(s); return d.innerHTML; }
    function rateMoney(v) {
      var n = parseFloat(v);
      if (isNaN(n)) return esc(v);
      return n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
    }
    function duty(c) { return EU.indexOf(c) > -1 ? "" : " Outside the EU, import duties/taxes may be charged by the carrier on delivery."; }
    function estimate(card) {
      card = card || $(".shipcard", pg7);
      var sel = card.querySelector(".js-country");
      var zipEl = card.querySelector(".js-zip");
      var box = card.querySelector(".js-shipres");
      var go = card.querySelector(".js-est");
      var sfEl = card.querySelector("[data-ship-variant]");
      var sVar = sfEl ? sfEl.getAttribute("data-ship-variant") : null;
      var country = sel.value, zip = (zipEl && zipEl.value || "").trim();
      if (!country || country === "---") { box.innerHTML = '<p class="srnote">Please choose a country.</p>'; return; }
      if (!sVar) { box.innerHTML = '<p class="srnote">Add the item to your cart to estimate shipping.</p>'; return; }
      box.innerHTML = '<p class="srnote">Calculating…</p>';
      go.disabled = true;
      var prev = 0;
      fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (cart) {
        (cart.items || []).forEach(function (it) { if (String(it.id) === String(sVar)) prev = it.quantity; });
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: parseInt(sVar, 10), quantity: 1 }) });
      }).then(function () {
        var qs = "shipping_address[country]=" + encodeURIComponent(country) + "&shipping_address[zip]=" + encodeURIComponent(zip);
        return fetch("/cart/shipping_rates.json?" + qs, { headers: { Accept: "application/json" } });
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); }).then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        var cc = CC[country];
        var head = '<div class="srh">' + (cc ? '<span class="flag cc-' + cc + '"></span>' : "") + "<b>Shipping to " + esc(country) + '</b><span class="srsame">Same rates as checkout</span></div>';
        if (!rates.length) {
          box.innerHTML = head + '<p class="srnote">No shipping options for that address — your exact cost shows at checkout.' + duty(country) + "</p>";
          return;
        }
        var rows = rates.map(function (rt) {
          return '<div class="srrow"><span>' + esc(rt.name || "Shipping") + "</span><i></i><b>" + rateMoney(rt.price) + "</b></div>";
        }).join("");
        box.innerHTML = head + rows + '<p class="srnote">Live rates for this item.' + duty(country) + "</p>";
      }).catch(function () {
        box.innerHTML = '<p class="srnote">Couldn’t fetch rates right now — your exact shipping cost is always shown at checkout.</p>';
      }).then(function () {
        go.disabled = false;
        /* change.js verlangt die id als STRING (\d+ oder \d+:key) — Number -> 400 */
        return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: String(sVar), quantity: prev }) });
      }).catch(function () {});
    }
    $$(".js-country", pg7).forEach(function (sel) {
      sel.addEventListener("change", function () {
        var f = sel.closest(".shipcard").querySelector(".js-shipflag");
        var cc = CC[sel.value];
        f.style.display = cc ? "" : "none";
        if (cc) f.className = "flag cc-" + cc + " js-shipflag";
      });
    });
    pg7.addEventListener("click", function (e) {
      var q = e.target.closest(".js-fq");
      if (q) { q.closest(".faq7").classList.toggle("on"); return; }
      var eb = e.target.closest(".js-est");
      if (eb) { estimate(eb.closest(".shipcard")); return; }
      var qt = e.target.closest(".js-qtab");
      if (qt) {
        $$(".js-qtab", pg7).forEach(function (x) { x.classList.toggle("on", x === qt); });
        $$(".qpane", pg7).forEach(function (pn) { pn.hidden = pn.getAttribute("data-c") !== qt.getAttribute("data-c"); });
      }
    });
  })();

  /* ================= 08 · Paddock ================= */
  var pg8mq = $(".pdpx.pg8 .js-mqin");
  if (pg8mq) (function () {
    var SPEED = 53; /* px/s — das Mockup-Tempo */
    var MINSET = 4000; /* ein Set muss breiter sein als der groesste Viewport */
    function tune() {
      var set = pg8mq.querySelector(".mqset");
      if (!set) return;
      var w = set.offsetWidth;
      if (w > 0) pg8mq.style.animationDuration = Math.round(w / SPEED) + "s";
    }
    function shortTitle(t) {
      t = String(t).replace("Shoei ", "").replace("X-SPR PRO ", "").replace("Helmet ", "").split(" - ")[0].split(" – ")[0];
      return t.length > 26 ? t.slice(0, 25) + "…" : t;
    }
    function imgUrl(u) {
      if (!u) return "";
      return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=400";
    }
    var pid = pg8mq.getAttribute("data-pid");
    if (pid) {
      fetch("/recommendations/products.json?product_id=" + pid + "&limit=10&intent=related", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (data) {
          var prods = (data && data.products) || [];
          if (prods.length < 3) { tune(); return; }
          var cards = prods.map(function (p) {
            return '<a class="mcard" href="' + p.url + '"><span class="mi" data-bg="' + imgUrl(p.featured_image) + '"></span><span class="mb"><b>' + shortTitle(p.title) + "</b><i>" + euro(p.price) + "</i></span></a>";
          }).join("");
          /* Set-HTML so oft wiederholen, bis ein Set breiter als MINSET ist */
          var probe = document.createElement("span");
          probe.className = "mqset";
          probe.style.visibility = "hidden";
          probe.innerHTML = cards;
          pg8mq.appendChild(probe);
          var one = probe.offsetWidth || 1;
          probe.remove();
          var reps = Math.max(1, Math.ceil(MINSET / one));
          var setHtml = new Array(reps + 1).join(cards);
          pg8mq.innerHTML = '<span class="mqset">' + setHtml + '</span><span class="mqset">' + setHtml + "</span>";
          if (window.__pdpxLazy) window.__pdpxLazy(pg8mq);
          tune();
        })
        .catch(function () { tune(); });
    } else { tune(); }
  })();

  /* ================= Persistente Folien-Leiste (R2 · Progress-Spine) ================= */
  var rail = $(".pdpxrail");
  var chipbar = $(".pdpxchips");
  if (chipbar) {
    $$(".pdpxchips button").forEach(function (b) {
      if (!document.querySelector(b.getAttribute("data-goto"))) b.style.display = "none";
    });
    chipbar.hidden = false;
    chipbar.addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b) return;
      var t = document.querySelector(b.getAttribute("data-goto"));
      if (t) t.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }
  if (rail) (function () {
    var targets = [];
    $$(".pdpxrail button").forEach(function (b) {
      var t = document.querySelector(b.getAttribute("data-goto"));
      if (t) targets.push({ b: b, t: t });
      else b.style.display = "none";
    });
    if (targets.length < 2) return;
    /* fortlaufend nummerieren — bei 4 Folien 1-2-3-4 statt 1-2-7-8 */
    targets.forEach(function (o, i) { var num = o.b.querySelector("b"); if (num) num.textContent = i + 1; });
    rail.hidden = false;
    /* Mobil: Rail zeigt sich nur WAEHREND des Scrollens, verschwindet bei Ruhe */
    var fadeT;
    window.addEventListener("scroll", function () {
      if (!window.matchMedia("(max-width:860px)").matches) return;
      rail.classList.add("live");
      clearTimeout(fadeT);
      fadeT = setTimeout(function () { rail.classList.remove("live"); }, 1400);
    }, { passive: true });
    var tube = rail.querySelector(".tube i");
    rail.addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b) return;
      var t = document.querySelector(b.getAttribute("data-goto"));
      if (t) t.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    /* rAF-gebuendelt (ein Lauf pro Frame): erst alle Rects lesen, dann schreiben */
    var spyQ = false;
    function spy() {
      if (spyQ) return; spyQ = true;
      requestAnimationFrame(function () {
        spyQ = false;
        var mid = scrollY + innerHeight * 0.38, idx = 0;
        var tops = targets.map(function (o) { return o.t.getBoundingClientRect().top + scrollY; });
        var last = targets[targets.length - 1].t.getBoundingClientRect();
        tops.forEach(function (t, i) { if (t <= mid) idx = i; });
        if (chipbar) {
          var chips = $$(".pdpxchips button").filter(function (c) { return c.style.display !== "none"; });
          targets.forEach(function (o, i) {
            var c = chips[i];
            if (!c) return;
            var on = i === idx;
            c.classList.toggle("on", on);
            if (on && c.scrollIntoView) c.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
          });
        }
        targets.forEach(function (o, i) {
          o.b.classList.toggle("on", i === idx);
          o.b.classList.toggle("done", i < idx);
        });
        var start = tops[0];
        var end = last.bottom + scrollY - innerHeight;
        var pct = end > start ? Math.min(1, Math.max(0, (scrollY - start) / (end - start))) : 0;
        tube.style.height = (pct * 100) + "%";
      });
    }
    addEventListener("scroll", spy, { passive: true });
    addEventListener("resize", spy);
    spy();
    setTimeout(spy, 900);
  })();
})();
